export default {
    login: "/api/police/v1/user/login_password.html",
    user_message_list: "/api/web/v1/user/user_message_list.html",
    user_message_list_new: "/api/web/v1/user/user_message_list_new.html",
    mark_some_message: "/api/web/v1/user/mark_some_message.html",
    mark_all_message: "/api/web/v1/user/mark_all_message.html",
    show_user_message: "/api/web/v1/user/showUserMessage.html",
    userinfo: "/api/web/v1/user/userinfo.html",
    set_system_data: "/api/web/v1/index/set_system_data.html",
    get_system_data: "/api/web/v1/index/get_system_data.html",
    set_system_config: "/api/web/v1/index/update_system_data",

    get_system_data_new: "/api/web/v1/index/get_system_data_new.html",
    get_system_code_new: "/api/web/v1/index/get_all_pcode.html",
    phonelogin:"/api/police/v1/user/login_mobile",
    idcardlogin:"/api/police/v1/user/login_idcard",
    codelogin:"/api/police/v1/user/login_sms",
    sendcode:"/api/v1/index/send_sms_code",
    login_acount_password: "/api/v1/user/login_acount_password",
    login_idcard_password: "/api/v1/user/login_idcard_password",
    login_phone_password: "/api/v1/user/login_phone_password",
    login_sms: "/api/v1/user/login_sms",
    loginname:"/admin/login/name",
    getVerifyInfo: "/api/web/v1/index/initSlideVerifyImage",


    newRuleAdd:"/api/system/role/add",
    newRuleEdit:"/api/system/role/edit",
    newRuleList:"/api/system/role/list",
    newRoleList:"/api/system/role/rolelist",
    newRuleDelete:"/api/system/role/delete",
    newRuleView: "/api/system/role/view",
    getAllMenu: "/api/web/v1/index/get_all_menu.html",
    getMenu: "/api/web/v1/index/get_menu.html",
    updateMenu: "/api/system/role/setAuthority",
    menuAdd: "/api/system/menu/add",
    menuEdit: "/api/system/menu/edit",
    menuDelete: "/api/system/menu/delete",
};